/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
import {
  Flex,
  FlexGap,
  NextLinkFromReactRouter,
  DropdownMenuItemType,
  Text,
  IconButton,
  useMatchBreakpoints,
  CloseIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@pancakeswap/uikit'
import styled from 'styled-components'
import { NetworkSwitcher } from 'components/ENetworkSwitcher'
import { useTranslation } from '@pancakeswap/localization'
// import { formatBigNumber, getBalanceNumber } from '@pancakeswap/utils/formatBalance'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useInterval } from '@pancakeswap/hooks'
import { gsap, Observer, prefersReducedMotion } from 'lib/motion'
import { useV2BurnerContract } from 'hooks/useContract'
import { BBC, CAKE, NINEINCH } from '@pancakeswap/tokens'
import { ChainId } from '@pancakeswap/chains'
import { useSingleCallResult } from 'state/multicall/hooks'
import { useTokenBalances } from 'state/wallet/hooks'
import useTotalSupply from 'hooks/useTotalSupply'
import { CurrencyLogo } from 'components/Logo'
import { CurrencyAmount } from '@pancakeswap/swap-sdk-core'
import { v2Clients, v3Clients } from 'utils/graphql'
import { fetchTotalValueLockedV2, fetchTotalValueLockedV3 } from 'views/V3Info/data/pool/poolData'
import { useTokenData } from 'views/V3Info/hooks'
import Link from 'next/link'
import UserMenu from '../UserMenu'


const MenuContainer = styled.div`
  font-size: 16px;
  font-weight: 300;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  padding: 0 16px;
  z-index: 20;
  background: ${({ theme }) => theme.colors.menuBackground};
  backdrop-filter: blur(20px) saturate(160%);
  -webkit-backdrop-filter: blur(20px) saturate(160%);
  border-bottom: 1px solid transparent;
  transition: border-color 250ms ease, box-shadow 250ms ease;

  &[data-scrolled='true'] {
    border-bottom-color: ${({ theme }) => theme.colors.menuDivider};
    box-shadow: 0 12px 32px -20px rgba(0, 0, 0, 0.9);
  }

  /* backdrop-filter needs something opaque behind it or the header reads as a
     hole in the page on browsers that ignore it */
  @supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
    background: ${({ theme }) => theme.colors.background};
  }

  ${({ theme }) => theme.mediaQueries._md} {
    height: 55px;
  }
`

const LogoWrapper = styled.div`
  width: 80px;
  object-fit: contain;
  & > svg {
    width: 100%;
    height: 100%;
  }

  ${({ theme }) => theme.mediaQueries._md} {
    width: 55px;
  }
`

const MenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #040005;
  opacity: 0.81;
  z-index: 9999;
`

const MenuBox = styled(FlexGap)`
  ${({ theme }) => theme.mediaQueries._md} {
    position: fixed;
    flex-direction: column;
    bottom: 50px;
    background-image: url('/assets/bg2.webp');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    left: 0;
    right: 0;
    padding: 16px;
    z-index: 99999;
    display: flex;
    height: fit-content;
    max-height: 90vh;

    > div:first-child {
      flex-shrink: 0;
    }

    > div:nth-child(2) {
      overflow-y: auto;
      max-height: calc(90vh - 80px);
    }
  }
`

const MenuItem = styled.div`
  position: relative;
  z-index: 2;

  .submenu {
    position: absolute;
    top: 100%;
    left: 0;
    display: none;
    margin: 4px 0;
    padding: 15px 0;
    border: 1px solid ${({ theme }) => theme.colors.menuBorder};
    border-radius: 16px;
    min-width: 15em;
    max-width: 340px;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.dropdown};
    backdrop-filter: blur(24px) saturate(160%);
    -webkit-backdrop-filter: blur(24px) saturate(160%);
    box-shadow: 0 24px 48px -20px rgba(0, 0, 0, 0.8);
    z-index: 3;
    & > hr {
      margin: 5px 20px 5px 25px;
      padding: 0;
      border-color: ${({ theme }) => theme.colors.menuDivider}; 
    }
    &::before {
      position: absolute;
      background: transparent;
      content: '';
      top: -10px;
      height: 10px;
      left: 0;
      right: 0;
    }
  }

  &:hover {
    .submenu {
      display: flex;
    }
  }

  > a, > span {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 14px 17.5px;
    border-radius: 15px;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.textSubtle};

    label {
      cursor: pointer;
    }

    &:not(.disabled) {
      cursor: pointer;
    }

    transition: background-color 200ms ease, color 200ms ease;

    &:not(.disabled):hover {
      background-color: ${({ theme }) => theme.colors.menuHover};
      color: ${({ theme }) => theme.colors.text};
    }

    &.active {
      color: ${({ theme }) => theme.colors.text};
      font-weight: bold;
      background-color: ${({ theme }) => theme.colors.menuHover};
      label {
        display: flex;
        align-items: center;
        gap: 4px;
      }
    }

    &.link-v2 {
      gap: 6px;
      &::after {
        background: ${({ theme }) => theme.colors.menuActiveDot};
        box-shadow: 0 0 8px ${({ theme }) => theme.colors.menuActiveDot};
        width: 8px;
        height: 8px;
        border-radius: 50%;
        content: '';
      }
    }

    & .active-icon {
      fill: ${({ theme }) => theme.colors.primary};
      position: absolute;
      left: 10px;
      top: 6px;
    }
  }

  ${({ theme }) => theme.mediaQueries._md} {
    .submenu {
      position: unset;
      display: block;
    }
    > a, > span {
      padding: 8px 4px;
      &:not(.disabled):hover {
        background: none;
      }
    }
  }
`

const SubMenuItem = styled.div`
  cursor: pointer;
  padding: 10px 20px 10px 25px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  white-space: normal;
  
  & > span {
    font-family: Inter;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.menuSubtle};
    & b, & i {
      font-family: inherit;
      color: ${({ theme }) => theme.colors.primary};
      font-weight: bold;
      &.soon {
        background: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.white};
        font-weight: normal;
        border-radius: 4px;
        padding: 2px 4px;
        text-transform: uppercase;
        margin-left: auto;
      }
    }
  }
  
  & > h5 {
    color: ${({ theme }) => theme.colors.menuSubtle};
    font-family: inherit;
    font-weight: 400;
    font-size: 20px;
    & b, & i {
      font-family: inherit;
      color: ${({ theme }) => theme.colors.primary};
      font-weight: bold;
    }
  }

  &:not(div) h5 {
    color: ${({ theme }) => theme.colors.secondary};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.menuHover};
  }

  ${({ theme }) => theme.mediaQueries._md} {
    white-space: wrap;
    font-size: 11px;
    & > h5 {
      font-size: 14px;
    }
  }
`

const SubMenuActive = styled.div`
  background: ${({ theme }) => theme.colors.menuActiveDot};
  box-shadow: 0 0 8px ${({ theme }) => theme.colors.menuActiveDot};
  width: 4px;
  height: 4px;
  border-radius: 15px;
  position: absolute;
  top: 8px;
  left: -8px;
`

const SocialLinks = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  padding: 24px;

  ${({ theme }) => theme.mediaQueries._md} {
    display: none;
  }
`

const MobileMenu = styled(Flex)`
  gap: 4px;
  align-items: center;
  ${({ theme }) => theme.mediaQueries.md} {
    display: none;
  }
`
const DesktopMenu = styled(Flex)`
  gap: 4px;
  flex-direction: row;
  margin: 10px 2px;
  justify-content: space-around;
  align-items: center;
  ${({ theme }) => theme.mediaQueries._md} {
    width: 100%;
  }

  ${({ theme }) => theme.mediaQueries._xl} {
    .for-md {
      display: none;
    }
  }

  ${({ theme }) => theme.mediaQueries._xxl} {
    .for-lg {
      display: none;
    }
  }
`

const Highlights = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-style: italic;
`

const MenuButton = styled(IconButton)`
  width: 22px;
  ${({ theme }) => theme.mediaQueries.md} {
    display: none;
  }
`

const BrandImage = () => (
  <svg width="57" height="20" viewBox="0 0 57 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.3576 7.0072C12.3728 7.1592 12.3804 7.3872 12.3804 7.6912C12.3804 9.7432 11.7344 11.7648 10.4424 13.756C9.1656 15.7472 7.2504 17.5332 4.6968 19.114L1.71 15.9676C2.394 15.6332 3.1312 15.1392 3.9216 14.4856C4.7272 13.832 5.4112 13.1556 5.9736 12.4564C4.864 12.4412 3.8684 12.1828 2.9868 11.6812C2.1052 11.1796 1.4212 10.5336 0.9348 9.7432C0.4484 8.9376 0.2052 8.094 0.2052 7.2124C0.2052 6.2396 0.494 5.32 1.0716 4.4536C1.6492 3.572 2.4092 2.8652 3.3516 2.3332C4.3092 1.8012 5.32 1.5352 6.384 1.5352C7.372 1.5352 8.322 1.7708 9.234 2.242C10.1612 2.7132 10.9136 3.3668 11.4912 4.2028C12.0688 5.0236 12.3576 5.9508 12.3576 6.9844V7.0072ZM4.3092 7.1212C4.3092 7.638 4.4688 8.1016 4.788 8.512C5.1224 8.9224 5.6012 9.1276 6.2244 9.1276C6.8172 9.1276 7.2808 8.9376 7.6152 8.5576C7.9648 8.1776 8.1396 7.7216 8.1396 7.1896C8.1396 6.5968 7.9344 6.1408 7.524 5.8216C7.1288 5.5024 6.6728 5.3428 6.156 5.3428C5.6544 5.3428 5.2212 5.5024 4.8564 5.8216C4.4916 6.1408 4.3092 6.574 4.3092 7.1212ZM15.4985 5.9812C15.0577 5.9812 14.6245 5.8672 14.1989 5.6392C13.7885 5.396 13.4465 5.0692 13.1729 4.6588C12.9145 4.2484 12.7853 3.8076 12.7853 3.3364C12.7853 2.6068 13.0589 1.9988 13.6061 1.5124C14.1685 1.026 14.8373 0.782799 15.6125 0.782799C16.3421 0.782799 16.9273 1.0032 17.3681 1.444C17.8241 1.8848 18.0521 2.47 18.0521 3.1996C18.0521 4.0052 17.8089 4.674 17.3225 5.206C16.8361 5.7228 16.2281 5.9812 15.4985 5.9812ZM13.0133 6.8476H17.7785V18.9316H13.3781L13.0133 6.8476ZM27.0315 6.6424C28.1563 6.6424 29.0455 7.0224 29.6991 7.7824C30.3527 8.5272 30.6643 9.5836 30.6339 10.9516L30.4971 19H26.3247L26.3475 13.642C26.3475 12.5324 26.1955 11.742 25.8915 11.2708C25.6027 10.7996 25.1695 10.564 24.5919 10.564C24.1207 10.564 23.7103 10.7008 23.3607 10.9744C23.0263 11.248 22.8211 11.7116 22.7451 12.3652L22.7679 19H18.6411V6.8476L22.7223 6.7792V7.942C23.2999 7.562 23.9763 7.2504 24.7515 7.0072C25.5267 6.764 26.2867 6.6424 27.0315 6.6424ZM37.1116 19.1596C36.002 19.1596 34.9684 18.8708 34.0108 18.2932C33.0532 17.7004 32.2932 16.9176 31.7308 15.9448C31.1684 14.9568 30.8872 13.9004 30.8872 12.7756C30.8872 11.6508 31.1532 10.6248 31.6852 9.6976C32.2324 8.7552 32.962 8.0104 33.874 7.4632C34.8012 6.916 35.8196 6.6424 36.9292 6.6424C37.9172 6.6424 38.8824 6.8704 39.8248 7.3264C40.7824 7.7824 41.5576 8.398 42.1504 9.1732C42.7432 9.9484 43.0396 10.7844 43.0396 11.6812L39.2092 12.0232C39.0724 11.5824 38.8216 11.2328 38.4568 10.9744C38.1072 10.7008 37.712 10.564 37.2712 10.564C36.6632 10.564 36.116 10.792 35.6296 11.248C35.1584 11.6888 34.9228 12.198 34.9228 12.7756C34.9228 13.1556 35.0368 13.528 35.2648 13.8928C35.4928 14.2576 35.7892 14.554 36.154 14.782C36.534 15.01 36.9216 15.124 37.3168 15.124C37.712 15.124 38.0844 15.01 38.434 14.782C38.7988 14.554 39.0572 14.2652 39.2092 13.9156L42.994 14.2804C42.994 15.1164 42.7052 15.9144 42.1276 16.6744C41.5652 17.4192 40.828 18.0196 39.916 18.4756C39.004 18.9316 38.0692 19.1596 37.1116 19.1596ZM52.0916 19V12.616C52.0916 11.9776 51.9016 11.476 51.5216 11.1112C51.1416 10.7464 50.6248 10.564 49.9712 10.564C48.892 10.564 48.1472 11.1264 47.7368 12.2512L47.828 18.9772L43.5416 18.9088L43.2224 0.623198H47.5544L47.6684 8.2612C48.1244 7.7444 48.7172 7.3264 49.4468 7.0072C50.1764 6.688 50.9136 6.5284 51.6584 6.5284C53.0568 6.5284 54.1664 7.0376 54.9872 8.056C55.8232 9.0744 56.2488 10.45 56.264 12.1828L56.3096 19H52.0916Z" fill="white" />
  </svg>
)

const LinkComponent = (linkProps: any) => {
  return <NextLinkFromReactRouter to={linkProps.href} {...linkProps} prefetch={false} />
}

const formatNumber = (value, precision = 6) => {
  if (!value) return '0'

  const k = 1000
  const sizes = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y']

  const i = value < 1 ? 0 : Math.floor(Math.log(value) / Math.log(k))

  return `${parseFloat((value / k ** i).toFixed(i ? 2 : precision))}${sizes[i]}`
}

const MobileStatsGrid = styled(Flex)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 8px; 
  width: 100%;
  margin-bottom: 16px;
  justify-content: center;
  justify-items: center;
  text-align: center;
  ${({ theme }) => theme.mediaQueries.sm} {
      grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`

const StatItem = styled(Flex)`
  flex-direction: row;
  align-items: center;
  gap: 4px;
  width: 100%;
  justify-content: flex-start;
  padding-left: 25%; 
`

const StatValue = styled(Flex)`
  align-items: center;
  gap: 4px;
  width: 100%;
  justify-content: flex-start;
  padding-left: 25%;  
`

const BurnIcon = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 9.83357C13 12.5902 10.7573 14.8336 8 14.8336C5.24267 14.8336 3 12.5902 3 9.83357C3 8.3349 3.428 7.26756 4.43066 6.26423C4.62733 6.0669 4.85 5.86956 5.08067 5.66556C6.02467 4.82956 7 3.96492 7 2.49958C7 2.37692 7.06801 2.26356 7.17601 2.20556C7.28401 2.14756 7.41534 2.15357 7.51801 2.22224C7.55801 2.2489 11.2767 4.79755 9.37 9.17622C9.81733 8.92622 10.3527 8.51621 10.6813 7.87955C10.892 7.47155 10.9993 7.00758 10.9993 6.49958C10.9993 6.36425 11.0813 6.24224 11.2067 6.19091C11.3307 6.13957 11.4753 6.16891 11.5707 6.26557C12.4793 7.18891 13 8.48957 13 9.83357Z" fill="#FF8F3F" />
  </svg>
)

const MobileMenuHeader = styled(FlexGap)`
  position: sticky;
  top: 16px;
  z-index: 100000;
  background: transparent;
  padding: 16px;
  width: 100%;
  margin-bottom: 16px;
`

const ScrambleValue = ({ value, ...textProps }: { value: string } & Record<string, any>) => {
  const ref = useRef<HTMLDivElement>(null)
  const prev = useRef<string>('')

  useEffect(() => {
    if (!ref.current || prefersReducedMotion()) return
    if (prev.current === value) return
    prev.current = value
    gsap.to(ref.current, {
      duration: 0.9,
      scrambleText: { text: value, chars: '0123456789', speed: 0.4 },
      ease: 'none',
    })
  }, [value])

  return (
    <Text ref={ref} {...textProps}>
      {value}
    </Text>
  )
}

const LeftMenu = ({ menuItems, activeItem, activeSubItem }) => {
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = menuRef.current
    if (!el) return undefined

    // Elevation is a state, not an animation: it tells the user content has
    // scrolled under the bar, so it runs even with reduced motion on.
    const onScroll = () => {
      el.dataset.scrolled = window.scrollY > 8 ? 'true' : 'false'
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })

    if (prefersReducedMotion()) {
      return () => window.removeEventListener('scroll', onScroll)
    }

    let hidden = false
    const observer = Observer.create({
      target: window,
      type: 'scroll',
      onDown: () => {
        if (!hidden && window.scrollY > 160) {
          hidden = true
          gsap.to(el, { yPercent: -100, duration: 0.35, ease: 'power2.out' })
        }
      },
      onUp: () => {
        if (hidden) {
          hidden = false
          gsap.to(el, { yPercent: 0, duration: 0.35, ease: 'power2.out' })
        }
      },
    })
    return () => {
      window.removeEventListener('scroll', onScroll)
      observer.kill()
    }
  }, [])
  const { t } = useTranslation()
  // const { chainId } = useActiveChainId()
  const [visibleMenu, setVisibleMenu] = useState(false)
  const [totalLiquidity, setTotalLiquidity] = useState(0)
  const [totalUSDValue, setTotalUSDValue] = useState(0)

  const [selectedMenu, selectMenu] = useState(0)

  const { isLg, isXl, isXxl } = useMatchBreakpoints()
  const isMobile = !isLg && !isXl && !isXxl

  const totalVauleLocked = useMemo(() => totalLiquidity + (totalUSDValue ?? 0), [totalLiquidity, totalUSDValue])

  const stats9INCH = useTokenData(NINEINCH[ChainId.PULSE].address.toLowerCase(), ChainId.PULSE)
  const statsBBC = useTokenData(BBC[ChainId.PULSE].address.toLowerCase(), ChainId.PULSE)
  const contractBurner = useV2BurnerContract()
  const burnt9INCH = useSingleCallResult({
    contract: contractBurner,
    functionName: 'burnedNineInch'
  })
  const burntBBC = useSingleCallResult({
    contract: contractBurner,
    functionName: 'burnedBBC'
  })
  const deadBalances = useTokenBalances('0x000000000000000000000000000000000000dEaD', [NINEINCH[ChainId.PULSE], CAKE[ChainId.PULSE]])
  const pulseBalances = useTokenBalances('0x0000000000000000000000000000000000000369', [NINEINCH[ChainId.PULSE], CAKE[ChainId.PULSE]])
  const supply9INCH = useTotalSupply(NINEINCH[ChainId.PULSE])
  const supplyBBC = useTotalSupply(CAKE[ChainId.PULSE])

  // Additional burned amount to add to 9INCH calculation
  const additionalBurnedAmount = useMemo(() =>
    CurrencyAmount.fromRawAmount(NINEINCH[ChainId.PULSE], '10596478808000000000000000000'), // Adding the specified amount with 18 decimals
    []
  )

  const percent9inchBurn = useMemo(() =>
    supply9INCH
      ? CurrencyAmount.fromRawAmount(NINEINCH[ChainId.PULSE], String(burnt9INCH?.result ? burnt9INCH.result : 0))
        .add(deadBalances && deadBalances[NINEINCH[ChainId.PULSE].address] ? deadBalances[NINEINCH[ChainId.PULSE].address]! : CurrencyAmount.fromRawAmount(NINEINCH[ChainId.PULSE], '0'))
        .add(pulseBalances && pulseBalances[NINEINCH[ChainId.PULSE].address] ? pulseBalances[NINEINCH[ChainId.PULSE].address]! : CurrencyAmount.fromRawAmount(NINEINCH[ChainId.PULSE], '0'))
        .add(additionalBurnedAmount) // Add the additional burned amount here
        .multiply(10 ** 20).divide(supply9INCH)
      : undefined,
    [burnt9INCH, supply9INCH, deadBalances, pulseBalances, additionalBurnedAmount])

  const percentBBCBurn = useMemo(() =>
    supplyBBC
      ? CurrencyAmount.fromRawAmount(CAKE[ChainId.PULSE], String(burntBBC?.result ? burntBBC.result : 0))
        .add(deadBalances && deadBalances[CAKE[ChainId.PULSE].address] ? deadBalances[CAKE[ChainId.PULSE].address]! : CurrencyAmount.fromRawAmount(CAKE[ChainId.PULSE], '0'))
        .add(pulseBalances && pulseBalances[CAKE[ChainId.PULSE].address] ? pulseBalances[CAKE[ChainId.PULSE].address]! : CurrencyAmount.fromRawAmount(CAKE[ChainId.PULSE], '0'))
        .multiply(10 ** 20).divide(supplyBBC)
      : undefined,
    [burntBBC, supplyBBC, deadBalances, pulseBalances])

  const fetchData = useCallback(() => {
    Promise.all([
      fetchTotalValueLockedV2(v2Clients[ChainId.PULSE]),
      fetchTotalValueLockedV2(v2Clients[ChainId.ETHEREUM]),
      fetchTotalValueLockedV3(v3Clients[ChainId.PULSE]),
    ]).then(([v2PulseTVL, v2EthTVL, v3TVL]) => {
      const total = v2PulseTVL + v2EthTVL + v3TVL
      setTotalLiquidity(total)
    })
    // fetch(`https://stats.9inch.io/get9inchStats`).then(res => res.json()).then((data: any) => {
    //   const usdPoolStaked: number = Object.values(data).reduce((sum: number, c: any) => {
    //     return sum + (c.totalPoolsStakedUSD ?? 0) + (c.totalBBCPoolsStakedUSD ?? 0) + (c.totalFarmsLiquidityUSD ?? 0) + (c.totalPrcFarmsLiquidityUSD ?? 0)
    //   }, 0)
    //   setTotalUSDValue(usdPoolStaked)
    // }).catch(ex => console.error(ex))
  }, [])

  useInterval(fetchData, 1000 * 60, true, true)

  const renderIcon = (IconComponent, FillIconComponent, isActive) => {
    if (typeof IconComponent === 'function' && typeof FillIconComponent === 'function') {
      return isActive ? <FillIconComponent color="primary" height="16px" /> : <IconComponent color="textSubtle" height="16px" />;
    }
    if (typeof IconComponent === 'function') {
      return <IconComponent color={isActive ? "primary" : "textSubtle"} height="16px" />;
    }
    return null;
  };

  const toggleMenu = (menuId) => {
    if (isMobile) {
      if (selectedMenu === menuId) {
        selectMenu(-1)
      } else {
        selectMenu(menuId)
      }
    }
  }

  const handleMenuItemClick = () => {
    if (isMobile) {
      setVisibleMenu(false)
      selectMenu(-1)
    }
  }

  return (
    <MenuContainer ref={menuRef}>
      <FlexGap justifyContent="space-between" gap="12px" alignItems="center">
        <MenuButton variant="text" height="auto" onClick={() => setVisibleMenu(true)}>
          <svg width="18" height="16" viewBox="0 0 18 16" fill="#FFFA" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0H18V2H0V0ZM0 7H12V9H0V7ZM0 14H18V16H0V14Z" />
          </svg>
        </MenuButton>
        <LogoWrapper style={{ cursor: "pointer" }} onClick={() => {
          window.location.href = 'https://app.9inch.io/swap?chain=pulse'
        }}>
          <BrandImage />
        </LogoWrapper>
      </FlexGap>
      {
        (!isMobile || visibleMenu) &&
        <>
          {isMobile && <MenuOverlay onClick={() => setVisibleMenu(false)} />}
          <MenuBox gap="12px" alignItems={["flex-start", "flex-start", "flex-start", "center"]} flex={1}>
            {
              isMobile &&
              <MobileMenuHeader gap="16px" alignItems="center">
                <CloseIcon height={24} onClick={() => setVisibleMenu(false)} />
                <LogoWrapper>
                  <BrandImage />
                </LogoWrapper>
              </MobileMenuHeader>
            }
            <Flex flexGrow={1} ml={[0, 0, "8px"]} flexDirection={["column", "column", "column", "row"]} mt={["30px", "30px", "30px", 0]} width={["100%", "100%", "100%", "auto"]}>
              {menuItems.map((item, menuId) => (
                <MenuItem key={item.label}>
                  {
                    !item.disabled && (
                      <LinkComponent
                        href={item.href ?? ''}
                        className={`${item === activeItem ? "active" : ""} ${item.disabled ? "disabled" : ""}`}
                        target={item.type === DropdownMenuItemType.EXTERNAL_LINK ? '_blank' : '_self'}
                        onClick={(e) => {
                          if (isMobile && item.items) {
                            e.preventDefault();
                            toggleMenu(menuId);
                          } else {
                            handleMenuItemClick();
                          }
                        }}
                      >
                        {(item.icon || item.fillIcon) && renderIcon(item.icon, item.fillIcon, item === activeItem)}
                        <label>{item.label}</label>
                        {isMobile && item.items && (
                          selectedMenu === menuId
                            ? <ChevronUpIcon ml="auto" />
                            : <ChevronDownIcon ml="auto" />
                        )}
                      </LinkComponent>
                    )
                  }
                  {item.items && (!isMobile || selectedMenu === menuId) ? (
                    <Flex className="submenu" flexDirection="column">
                      {item.items.map((subItem) => (
                        subItem.type === DropdownMenuItemType.DIVIDER
                          ? <hr key={`hr-${subItem.label}`} />
                          : <SubMenuItem
                            key={subItem.label}
                            as={subItem.disabled ? undefined : LinkComponent}
                            href={subItem.href}
                            target={subItem.type === DropdownMenuItemType.EXTERNAL_LINK ? '_blank' : '_self'}
                            onClick={handleMenuItemClick}
                          >
                            <p style={{ fontSize: "18px" }}>
                              {subItem.label}
                              {subItem.highlights && (<Highlights>{subItem.highlights}</Highlights>)}
                            </p>
                            {!!subItem.subtitle && <span>{subItem.subtitle}</span>}
                          </SubMenuItem>
                      ))}
                    </Flex>
                  ) : null}
                </MenuItem>
              ))}
            </Flex>

            {/* Move mobile stats outside of DesktopMenu */}
            {isMobile && (
              <MobileStatsGrid>
                <StatItem>
                  <Text color="textSubtle" fontSize="12px">TVL: </Text>
                  <Text fontSize={14} color="white">
                    ${formatNumber(totalVauleLocked, 2)}
                  </Text>
                </StatItem>
                <StatValue>
                  <CurrencyLogo currency={NINEINCH[ChainId.PULSE]} />
                  <Text fontSize={14} color={stats9INCH?.priceUSDChange > 0 ? "success" : "failure"}>
                    {stats9INCH?.priceUSDChange > 0 ? "↑" : "↓"}
                    {stats9INCH?.priceUSDChange?.toFixed(2) ?? 0}%
                  </Text>
                </StatValue>
                <StatValue>
                  <CurrencyLogo currency={NINEINCH[ChainId.PULSE]} />
                  <Text fontSize={14} color="white">
                    {percent9inchBurn?.toFixed(2) ?? 0}%
                  </Text>
                  <BurnIcon />
                </StatValue>
                <StatValue>
                  <CurrencyLogo currency={CAKE[ChainId.PULSE]} />
                  <Text fontSize={14} color="white">
                    {percentBBCBurn?.toFixed(2) ?? 0}%
                  </Text>
                  <BurnIcon />
                </StatValue>
              </MobileStatsGrid>
            )}

            <DesktopMenu>
              <Flex flexDirection="column" mr="32px" className="for-md">
                <Text color="textSubtle" fontSize="12px" lineHeight={1}>
                  {t('TVL: ')}
                </Text>
                <ScrambleValue
                  value={`$${formatNumber(totalVauleLocked, 2)}`}
                  fontSize={14}
                  color="white"
                  lineHeight="24px"
                />
              </Flex>
              <Flex flexDirection="column" className="for-lg">
                <Text color="textSubtle" fontSize="12px" lineHeight={1}>
                  {t('Burned')}
                </Text>
                <Flex>
                  <FlexGap alignItems="center" mr="32px" gap="10px" className="for-lg">
                    <CurrencyLogo currency={NINEINCH[ChainId.PULSE]} />
                    <Text fontSize={14} color="white">
                      {percent9inchBurn?.toFixed(2) ?? 0}%
                    </Text>
                  </FlexGap>
                  <FlexGap alignItems="center" mr="32px" gap="10px" className="for-lg">
                    <CurrencyLogo currency={CAKE[ChainId.PULSE]} />
                    <Text fontSize={14} color="white">
                      {percentBBCBurn?.toFixed(2) ?? 0}%
                    </Text>
                  </FlexGap>
                </Flex>
              </Flex>
              <Flex flexDirection="column" className="for-lg">
                <Text color="textSubtle" fontSize="12px" lineHeight={1}>
                  {t('Price')}
                </Text>
                <Flex>
                  {
                    !!stats9INCH?.priceUSDChange &&
                    <Link href="https://dexscreener.com/pulsechain/0x3ca80d83277e721171284667829c686527B8b3c5" target="_blank" rel="noopener noreferrer">
                      <FlexGap alignItems="center" mr="32px" gap="10px" className="for-md">
                        <CurrencyLogo currency={NINEINCH[ChainId.PULSE]} />
                        <Text fontSize={14} color={stats9INCH.priceUSDChange > 0 ? "success" : "failure"}>
                          {stats9INCH.priceUSDChange > 0 ? "↑" : "↓"}
                          {stats9INCH.priceUSDChange.toFixed(2) ?? 0}%
                        </Text>
                      </FlexGap>
                    </Link>
                  }
                  {
                    !!statsBBC?.priceUSDChange &&
                    <Link href="https://dexscreener.com/pulsechain/0x8b4cfb020aF9AcAd95AD80020cE8f67FBB2C700E" target="_blank" rel="noopener noreferrer">
                      <FlexGap alignItems="center" mr="32px" gap="10px" className="for-md">
                        <CurrencyLogo currency={BBC[ChainId.PULSE]} />
                        <Text fontSize={14} color={statsBBC.priceUSDChange > 0 ? "success" : "failure"}>
                          {statsBBC.priceUSDChange > 0 ? "↑" : "↓"}
                          {statsBBC.priceUSDChange.toFixed(2) ?? 0}%
                        </Text>
                      </FlexGap>
                    </Link>
                  }
                </Flex>
              </Flex>
              <NetworkSwitcher />
              {!isMobile && <UserMenu />}
            </DesktopMenu>
          </MenuBox>
        </>
      }
      <MobileMenu>
        <UserMenu />
      </MobileMenu>
    </MenuContainer>
  )
}

export default LeftMenu